import { useAppStore } from '@/store';
import { LoginModuleConfiguration } from '@/types';

export function useSiteConfig() {
    const appStore = useAppStore();

    const redirectToTechSupport = () => {
        const siteConfiguration = appStore.siteConfiguration as LoginModuleConfiguration;
        const supportUrl = siteConfiguration?.nonSecureUrls?.technicalSupport;
        if (supportUrl) {
            window.open(supportUrl, '_blank');
        }
    };

    return {
        redirectToTechSupport
    };
}